<template>
  <div class="footer">
    <footer>
      <div class="container">
        <p>
          Copyright © 2019 <a target="blank" href="https://observeit.com">ObserveIT</a>
        </p>
      </div>
    </footer>
  </div>
</template>
<script>
 export default {
   name: 'PortalFooter'
 }
</script>

<style>
 .footer {
     padding-top: .5em;
     margin-left: 10%;
     margin-right: 10%;
     border-top: 1px solid #a39c9b;
     background-color: white;
     text-align: center;
     margin-top: 0.8em;
 }

 .footer a {
     color: #00a1c8;
 }
</style>
